<template>
  <div class="containerProposal">
    <!-- <v-row class="d-flex justify-end mb-2 my-button" v-if="!isEditing">
      <v-col cols="12" md="auto" class="mb-6 myButtonProposal">
        <BaseButton
          v-html="'EDITAR PROPOSTA'"
          class="secondary"
          width="100%"
          @click="editProposal"
          v-if="userIsEmployee"
        />
      </v-col>
    </v-row> -->
    <QuotationBackButton
      class="buttonBack"
      v-if="
        (this.proposalForm.numero_proposta == null || isEditing) &&
          this.userIsEmployee
      "
      @back="previousStep"
    />
    <QuotationProposalAwaitingMessage v-if="enableAwaitingMessage" />
    <QuotationProposalViewer
      :product="product"
      :form="proposalForm"
      v-if="enableViewer"
    />
    <QuotationProposalForm
      :navigation-draft="navigationDraft"
      ref="formEl"
      :form="proposalForm"
      :headerText="stepText"
      :product="product"
      v-if="enableForm"
    />
    <BaseFooter>
      <v-row>
        <v-spacer />
        <v-col
          cols="12"
          sm="5"
          md="3"
          class="pr-0 pr-sm-5 pb-5 pb-sm-0"
          v-if="isEditing && hasProposal"
        >
          <BaseButton
            v-html="'CANCELAR'"
            class="white--text pink"
            width="100%"
            @click="cancel()"
          />
        </v-col>
        <v-col cols="12" sm="5" md="3" v-if="allowNext">
          <BaseButton
            v-html="stepText"
            class="white--text secondary"
            width="100%"
            @click="submit()"
          />
        </v-col>
      </v-row>
    </BaseFooter>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import { formatDDMMYYYYToIsoDate } from "@/utils/formats.js";
import QuotationProposalForm from "../components_agro/QuotationProposalForm.vue";
import QuotationBackButton from "../components_agro/QuotationBackButton";
import QuotationProposalViewer from "../components_agro/QuotationProposalViewer.vue";
import QuotationProposalAwaitingMessage from "../components_agro/QuotationProposalAwaitingMessage.vue";
import { QuotationMixin } from "@/mixins/NewQuotationMixin";
import PolicyMixin from "@/mixins/PolicyMixin";
import _ from "lodash";

export default {
  name: "QuotationStepProposal",
  components: {
    QuotationProposalForm,
    QuotationProposalViewer,
    QuotationProposalAwaitingMessage,
    QuotationBackButton
  },
  mixins: [LoadingRequest, QuotationMixin, PolicyMixin],
  data() {
    return {
      formatDDMMYYYYToIsoDate,
      proposalForm: null,
      isEditing: false
    };
  },
  created() {
    this.initializeForm();
    if (!this.proposalForm.numero_proposta && this.userIsEmployee) {
      this.isEditing = true;
    }
  },
  methods: {
    getFormForNavigation() {
      return this.proposalForm;
    },
    ...mapActions("quotation", ["submitProposalAgro", "submitProposalCafezal"]),
    previousStep() {
      this.$emit(
        "updateStep",
        this.payloadQuotation(this.proposalForm, this.previousQuotationStep)
      );
    },
    editProposal() {
      this.isEditing = true;
    },
    cancelEdit() {
      this.isEditing = false;
    },
    cancel() {
      if (!this.isEditing || !this.hasProposal) {
        this.$emit("cancel");
      } else {
        this.isEditing = false;
      }
    },
    async submit() {
      if (this.isEditing) {
        let validation = this.$refs.formEl.validate();
        if (validation === true) {
          // envia arquivos
          const form = await this.submitFormFiles(this.$refs.formEl.editForm);

          // envia alterações
          if (this.product == "agricola") {
            this.submitFormDataAgro(form);
          } else {
            this.submitFormDataCafezal(form);
          }
        } else {
          this.showAlertNotification({
            message: validation,
            type: "error"
          });
        }
      } else {
        this.$emit(
          "updateStep",
          this.payloadQuotation(this.proposalForm, this.nextQuotationStep)
        );
      }
    },
    async submitFormFiles(form) {
      let filesProposal = await this.withLoading(
        this.submitFiles(form.arquivo_proposta)
      );

      if (filesProposal != null && filesProposal.length > 0) {
        form.arquivo_link = filesProposal[0].url;
        form.arquivo_nome = filesProposal[0].nome;
      }

      let filesBilling = await this.withLoading(
        this.submitFiles(form.arquivo_boleto)
      );

      if (filesBilling != null && filesBilling.length > 0) {
        form.boleto_link = filesBilling[0].url;
        form.boleto_nome = filesBilling[0].nome;
      }

      return form;
    },
    async submitFormDataAgro(form) {
      await this.withLoading(
        this.submitProposalAgro(this.prepareProposalPayload(form)).then(
          value => {
            let proposal = value.custos.find(
              x => x.numero_proposta != null && x.numero_proposta.length > 0
            );
            if (proposal != null) {
              this.cloneProposal(proposal);
              this.isEditing = false;
            }
          }
        )
      );
    },
    async submitFormDataCafezal(form) {
      await this.withLoading(
        this.submitProposalCafezal(
          this.prepareProposalCafezalPayload(form)
        ).then(value => {
          let proposal = value;
          if (proposal != null) {
            this.cloneProposal(proposal);
            this.isEditing = false;
          }
        })
      );
    },
    cloneProposal(proposal) {
      this.proposalForm = _.cloneDeep(proposal);
      if (this.product == "agricola") {
        this.proposalForm.tipo_seguro.nome =
          this.proposalForm.tipo_seguro.nome ??
          this.proposalForm.tipo_seguro.name;
        this.proposalForm.tipo_reivindicacao.nome =
          this.proposalForm.tipo_reivindicacao.nome ??
          this.proposalForm.tipo_reivindicacao.name;
        this.proposalForm.tipo_cobertura.nome =
          this.proposalForm.tipo_cobertura.nome ??
          this.proposalForm.tipo_cobertura.name;
      }
      this.proposalForm.forma_pagamento.nome =
        this.proposalForm.forma_pagamento.nome ??
        this.proposalForm.forma_pagamento.name;
    },
    prepareProposalPayload(payload) {
      return {
        id: payload.id,
        payload: {
          ...payload,
          inicio_vigencia: this.formatDDMMYYYYToIsoDate(
            payload.inicio_vigencia
          ),
          fim_vigencia: this.formatDDMMYYYYToIsoDate(payload.fim_vigencia),
          tipo_seguro_id: payload.tipo_seguro.id,
          tipo_cobertura_id: payload.tipo_cobertura.id,
          tipo_reivindicacao_id: payload.tipo_reivindicacao.id,
          forma_pagamento_id: payload.forma_pagamento.id
        }
      };
    },
    prepareProposalCafezalPayload(payload) {
      return {
        ...payload,
        inicio_vigencia: this.formatDDMMYYYYToIsoDate(payload.inicio_vigencia),
        fim_vigencia: this.formatDDMMYYYYToIsoDate(payload.fim_vigencia)
      };
    },
    initializeForm() {
      if (this.form == null || this.form.id == null) {
        this.proposalForm = this.parseCostsData(
          this.formCosts?.selectedCost,
          this.formCosts?.forma_pagamento
        );
        return;
      }

      this.cloneProposal(this.form);
    },
    parseCostsData(data, payment) {
      if (data == null) {
        return null;
      }

      if (data.tipo_seguro) {
        return _.cloneDeep(data);
      }

      if (this.product == "cafezal") {
        data.forma_pagamento = payment;
        return data;
      } else {
        return {
          id: data.id,
          numero_proposta: null,
          inicio_vigencia: null,
          fim_vigencia: null,
          tipo_seguro: {
            id: data.insuranceType.id,
            nome: data.insuranceType.nome
          },
          seguradora: data.insuranceCompany,
          area_segurada: data.insuredArea,
          tipo_reivindicacao: {
            id: data.claimType.id,
            nome: data.claimType.nome
          },
          tipo_cobertura: {
            id: data.coverage.id,
            nome: data.coverage.nome
          },
          importancia_segurada: data.insuredValue,
          producao_garantida: data.grantedProduction,
          custo_por_saca: data.costPerSac,
          custo_por_hectare: data.hectareCost,
          custo_total: data.total,
          subvencao_federal: data.federalSubvention,
          subvencao_estadual: data.stateSubvention,
          custo_segurado: data.insuredPrice,
          custo_produtor: data.farmerPrice,
          forma_pagamento: {
            id: payment ? payment.id : data.paymentForm.id,
            nome: payment ? payment.name : data.paymentForm.nome
          }
        };
      }
    }
  },
  computed: {
    ...mapState("me", ["userIsEmployee", "myInfo"]),
    nextQuotationStep() {
      return {
        name: "quotation step agreement",
        step: 9
      };
    },
    previousQuotationStep() {
      return {
        name: "quotation step risk2",
        step: 7
      };
    },
    hasProposal() {
      return this.proposalForm.numero_proposta != null;
    },
    enableForm() {
      return this.isEditing;
    },
    enableViewer() {
      return !this.isEditing && this.hasProposal;
    },
    enableAwaitingMessage() {
      return !this.userIsEmployee && !this.hasProposal;
    },
    allowNext() {
      return this.isEditing || this.hasProposal;
    },
    stepText() {
      return !this.isEditing
        ? "PRÓXIMO"
        : this.hasProposal
        ? "SALVAR ALTERAÇÔES"
        : "INSERIR PROPOSTA";
    }
  },
  props: {
    navigationDraft: {
      type: Object
    },
    form: {
      type: Object
    },
    product: {
      type: String
    },
    formCosts: {
      type: Object
    }
  }
};
</script>

<style lang="sass">
.containerProposal
  max-width: 95% !important
  margin: 0 auto !important
.myButtonProposal
  margin-top: -48px !important
  margin-bottom: 10px !important
  margin-right: -33px !important
.buttonBack
  margin-top: -40px
  margin-bottom: 8px
</style>
